export default {
  modalHeader: {
    id: 'seller_flash_sales_modal_header',
    defaultMessage: 'Deals',
  },
  loading: {
    id: 'spinner',
    defaultMessage: 'Loading',
  },
  emptyTitle: {
    id: 'seller_flash_sales_modal_empty_title',
    defaultMessage: 'Oops, there are no offers available anymore',
  },
  emptyDescription: {
    id: 'seller_flash_sales_modal_empty_description',
    defaultMessage:
      'New deals appear regularly... but they disappear very fast.',
  },
} as const
